// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","month":"_2ArR3NlPBjiN _3_c1hLwLZh4E","week":"_3JYtPrhqX9Zp","week_withPrice":"_2TJhvYZKVkc_"};